import { render, staticRenderFns } from "./InStoreBoard.vue?vue&type=template&id=6f693cb8&scoped=true&"
import script from "./InStoreBoard.vue?vue&type=script&lang=js&"
export * from "./InStoreBoard.vue?vue&type=script&lang=js&"
import style0 from "./InStoreBoard.vue?vue&type=style&index=0&id=6f693cb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f693cb8",
  null
  
)

export default component.exports